// what changed in the field: incoming project file vs. the version already on this PC
const SKIP = new Set(['updatedAt', 'createdAt', 'id', 'media', 'memos', 'photos', 'sug']);
const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
const cnt = (o, k) => (Array.isArray(o?.[k]) ? o[k].length : 0);
const llOf = (o, fits) => (o?.lat != null ? [o.lat, o.lon] : o?.points?.[0]?.fid ? (() => { const f = fits.find((x) => x.id === o.points[0].fid); return f ? [f.lat, f.lon] : null; })() : Array.isArray(o?.points?.[0]) ? o.points[0] : o?.points?.[0]?.lat != null ? [o.points[0].lat, o.points[0].lng ?? o.points[0].lon] : null);
const FIELD = (k) => (['lat', 'lon', 'points', 'pts'].includes(k) ? 'pos' : ['elev', 'z', 'depth'].includes(k) ? 'elev' : ['hyd', 'sw'].includes(k) ? 'hyd' : ['name', 'title', 'state', 'note', 'dn', 'material', 'type', 'text', 'address', 'description'].includes(k) ? k : 'more');

function diffList(kind, A = [], B = [], fits, nameOf) {
  const a = Object.fromEntries(A.map((o) => [o.id, o])), b = Object.fromEntries(B.map((o) => [o.id, o])), out = [];
  B.forEach((o) => {
    const p = a[o.id];
    if (!p) { out.push({ kind, act: 'new', id: o.id, name: nameOf(o), ll: llOf(o, fits), media: cnt(o, 'media') + cnt(o, 'photos'), memos: cnt(o, 'memos') }); return; }
    const keys = [...new Set([...Object.keys(p), ...Object.keys(o)])].filter((k) => !SKIP.has(k) && !same(p[k], o[k]));
    const media = cnt(o, 'media') + cnt(o, 'photos') - cnt(p, 'media') - cnt(p, 'photos'), memos = cnt(o, 'memos') - cnt(p, 'memos');
    if (keys.length || media || memos) out.push({ kind, act: 'chg', id: o.id, name: nameOf(o), ll: llOf(o, fits), fields: [...new Set(keys.map(FIELD))], media, memos });
  });
  A.forEach((o) => { if (!b[o.id]) out.push({ kind, act: 'del', id: o.id, name: nameOf(o), ll: llOf(o, A === fits ? A : fits) }); });
  return out;
}

export function fieldDiff(old, nu) {
  const fits = [...(nu.fittings || []), ...(old.fittings || [])], nm = (o) => o.name || o.title || o.type || String(o.id).slice(-5);
  const items = [
    ...['title', 'address', 'description'].filter((k) => !same(old[k], nu[k])).map((k) => ({ kind: 'project', act: 'chg', id: k, name: nu.title, fields: [k] })),
    ...diffList('fitting', old.fittings, nu.fittings, fits, nm),
    ...diffList('pipe', old.pipes, nu.pipes, fits, nm),
    ...diffList('report', old.reports, nu.reports, fits, nm),
    ...diffList('plan', old.plans, nu.plans, fits, nm),
  ];
  const sum = { new: 0, chg: 0, del: 0, media: 0 };
  items.forEach((i) => { sum[i.act]++; sum.media += Math.max(0, i.media || 0); });
  return { items, sum, oldAt: old.updatedAt, newAt: nu.updatedAt };
}
